export function notNullGuard<T>(v: T | null): v is T {
    return v !== null;
}

export function notGuard<T>(v: T | null | undefined): v is T {
    return !!v;
}

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType[number];
